/**
 * Internationalization (i18n) configuration for Kleaners
 * This file sets up the basic i18n infrastructure without translations
 */

export interface Locale {
  code: string;
  name: string;
  flag: string;
  direction: 'ltr' | 'rtl';
}

export const supportedLocales: Locale[] = [
  {
    code: 'bg',
    name: 'Български',
    flag: '🇧🇬',
    direction: 'ltr',
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    direction: 'ltr',
  },
  {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
    direction: 'ltr',
  },
];

export const defaultLocale = 'bg';

export function getLocaleFromPathname(pathname: string): string {
  const segments = pathname.split('/');
  const firstSegment = segments[1];

  if (supportedLocales.some(locale => locale.code === firstSegment)) {
    return firstSegment;
  }

  return defaultLocale;
}

/**
 * Prefix a pathname with the locale segment.
 * Matches `localePrefix: 'always'` in `i18n/routing.ts` — every locale including
 * the default (`bg`) gets an explicit `/{locale}` prefix.
 */
export function getLocalizedPath(pathname: string, locale: string): string {
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const withoutLocale = getPathWithoutLocale(normalized);
  const suffix = withoutLocale === '/' ? '' : withoutLocale;
  return `/${locale}${suffix}`;
}

export function getPathWithoutLocale(pathname: string): string {
  const segments = pathname.split('/');
  const firstSegment = segments[1];

  if (supportedLocales.some(locale => locale.code === firstSegment)) {
    return `/${segments.slice(2).join('/')}`;
  }

  return pathname;
}

// Placeholder for future translation functions
export function t(key: string, _locale: string = defaultLocale): string {
  // For now, return the key as-is
  // In the future, this will look up translations from translation files
  return key;
}

export function getTranslations(_locale: string = defaultLocale) {
  // Placeholder for future translation object
  // In the future, this will return the translation object for the locale
  return {};
}
